import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage/index';
import { ActivitiesPage } from './pages/ActivitiesPage/index';
import { ContactPage } from './pages/ContactPage/index';
import { SportingClaysPage } from './pages/SportingClaysPage/index';
import { SportingClaysScoresPage } from './pages/SportingClaysScoresPage/index';
import { CowboyActionPage } from './pages/CowboyActionPage/index';
import { SteelChallengePage } from './pages/SteelChallengePage/index';
import { ArcheryPage } from './pages/ArcheryPage/index';
import { JrRiflePage } from './pages/JrRiflePage/index';
import { PPCShootingPage } from './pages/PPCShootingPage/index';
import { BowlingPinPage } from './pages/BowlingPinPage/index';
import { SelfDefensePage } from './pages/SelfDefensePage/index';
import { RefuseVictimPage } from './pages/RefuseVictimPage/index';
import { RangeSafetyOfficerPage } from './pages/RangeSafetyOfficerPage/index';
import { FirstStepsPistolPage } from './pages/FirstStepsPistolPage/index';
import { CPLCoursePage } from './pages/CPLCoursePage/index';
import { CPLRenewalPage } from './pages/CPLRenewalPage/index';
import { PersonalProtectionPage } from './pages/PersonalProtectionPage/index';
import { CRASEPage } from './pages/CRASEPage/index';
import { CalendarPage } from './pages/CalendarPage/index';
import { ClubhouseRentalPage } from './pages/ClubhouseRentalPage/index';
import { NewsletterPage } from './pages/NewsletterPage/index';
import { RangeRulesPage } from './pages/RangeRulesPage/index';
import { PhotoTourPage } from './pages/PhotoTourPage/index';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage/index';
import { ConstitutionPage } from './pages/ConstitutionPage/index';
import { PoliciesPage } from './pages/PoliciesPage/index';
import { ElectionPage } from './pages/ElectionPage/index';
import { MembershipPage } from './pages/MembershipPage/index';
import { PolicePistolMatchPage } from './pages/PolicePistolMatchPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        {/* Home */}
        <Route path="/" element={<HomePage data-id="element-3" />} data-id="element-2" />

        {/* Activities */}
        <Route path="/Activities.html" element={<ActivitiesPage data-id="element-5" />} data-id="element-4" />
        <Route path="/SportingClays.html" element={<SportingClaysPage data-id="element-7" />} data-id="element-6" />
        <Route path="/SportingClaysScoresEvents.html" element={<SportingClaysScoresPage data-id="element-9" />} data-id="element-8" />
        <Route path="/SASS.html" element={<CowboyActionPage data-id="element-11" />} data-id="element-10" />
        <Route path="/SteelChallenge.html" element={<SteelChallengePage data-id="element-13" />} data-id="element-12" />
        <Route path="/3DArchery.html" element={<ArcheryPage data-id="element-15" />} data-id="element-14" />
        <Route path="/JrRifle.htm" element={<JrRiflePage data-id="element-17" />} data-id="element-16" />
        <Route path="/PPCShooting.html" element={<PPCShootingPage data-id="element-19" />} data-id="element-18" />
        <Route path="/BowlingPinShoots.html" element={<BowlingPinPage data-id="element-21" />} data-id="element-20" />

        {/* Firearms Education */}
        <Route path="/FLSCSelfDefense.html" element={<SelfDefensePage data-id="element-23" />} data-id="element-22" />
        <Route path="/RefuseToBeAVictim.html" element={<RefuseVictimPage data-id="element-25" />} data-id="element-24" />
        <Route path="/NRARangeSafetyOfficer.html" element={<RangeSafetyOfficerPage data-id="element-27" />} data-id="element-26" />
        <Route path="/NRAFirstStepsPistol.html" element={<FirstStepsPistolPage data-id="element-29" />} data-id="element-28" />
        <Route path="/NRAPersonalProtectionInTheHome.html" element={<CPLCoursePage data-id="element-31" />} data-id="element-30" />
        <Route path="/MICPLRenewalClass.html" element={<CPLRenewalPage data-id="element-33" />} data-id="element-32" />
        <Route path="/NRAPersonalProtectionOutsideTheHome.html" element={<PersonalProtectionPage data-id="element-35" />} data-id="element-34" />
        <Route path="/CRASE.html" element={<CRASEPage data-id="element-37" />} data-id="element-36" />

        {/* Club Info */}
        <Route path="/Calendar.html" element={<CalendarPage data-id="element-39" />} data-id="element-38" />
        <Route path="/ClubhouseRental.html" element={<ClubhouseRentalPage data-id="element-41" />} data-id="element-40" />
        <Route path="/FLSCNewsletter.html" element={<NewsletterPage data-id="element-43" />} data-id="element-42" />
        <Route path="/RangeRules.html" element={<RangeRulesPage data-id="element-45" />} data-id="element-44" />
        <Route path="/PhotoTour.html" element={<PhotoTourPage data-id="element-47" />} data-id="element-46" />
        <Route path="/PrivacyPolicy.html" element={<PrivacyPolicyPage data-id="element-49" />} data-id="element-48" />

        {/* Members */}
        <Route path="/ConstitutionAndByLaws.html" element={<ConstitutionPage data-id="element-51" />} data-id="element-50" />
        <Route path="/PoliciesAndProcedures.html" element={<PoliciesPage data-id="element-53" />} data-id="element-52" />
        <Route path="/FLSCElection2026.html" element={<ElectionPage data-id="element-55" />} data-id="element-54" />

        {/* Other */}
        <Route path="/Apply-For-Membership" element={<MembershipPage data-id="element-57" />} data-id="element-56" />
        <Route path="/ContactUs.html" element={<ContactPage data-id="element-59" />} data-id="element-58" />
        <Route path="/police-pistol-combat-match" element={<PolicePistolMatchPage data-id="element-61" />} data-id="element-60" />
      </Routes>
    </BrowserRouter>;
}